import React, {FC} from 'react'
import {RouteComponentProps} from 'react-router-dom'
import StylesType from '@/types/StylesType'
import Services from '@/components/service/ServiceItem'

export type ServiceTypes = RouteComponentProps & StylesType

const Service: FC<ServiceTypes> = props => {
    return (
    <>
      <Services></Services>
    </>
    )
}

export default Service
